export default __webpack_public_path__ + "static/media/img--bathroom-light.8166c8d7.jpg";